import api from './../libs/api';

export default {


get: (params = {}) => {
  return new Promise((resolve, reject) => {
      api()
          .get(`/users`, { params })
          .then(({ status, data }) => {
              if (status === 200) resolve(data);
              throw new Error(`Failed with status: ${status}`);
          })
          .catch(error => reject(error));
  });
},

updateDailyLimit: (userId, limit) => {
  return new Promise((resolve, reject) => {
    api()
      .put(`/users/${userId}/daily-purchase-limit`, { daily_purchase_limit: limit })
      .then(({ status, data }) => {
        if (status === 200) resolve(data);
        throw new Error(`Failed with status: ${status}`);
      })
      .catch(error => reject(error));
  });
},

}